import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useSystemStateHooks } from '../../system'
import { Category } from '../state/types'

export const useCategoryBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCategory = (data: Data2) => {
        const {
            id = newId(),
            name,
            imageUrl,
            archived
        } = data

        const category: Category = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            imageUrl: imageUrl as O<string>,
            archived: !!archived
        }

        return category
    }

    return {
        buildCategory
    }
}
